/**
 * Renders a row of small candy photos under any cart line's "Candy Selections"
 * property, so whoever is packing the order can see the actual candies at a
 * glance instead of only reading a text list. Uses the name -> image lookup
 * rendered by snippets/candy-thumbnail-map.liquid.
 */
(function () {
  var PROPERTY_NAME = 'Candy Selections';

  function getMap() {
    var el = document.getElementById('candy-thumbnail-map');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return null;
    }
  }

  function buildThumbsHtml(text, map) {
    var html = '';

    text.split(', ').forEach(function (entry) {
      var match = entry.match(/^(.*?)\s*\(x(\d+)\)$/);
      var name = match ? match[1] : entry.trim();
      var qty = match ? match[2] : null;
      var src = map[name];
      if (!src) return;

      html +=
        '<span class="cart-items__candy-thumb">' +
        '<img src="' + src + '" alt="" loading="lazy" width="32" height="32">' +
        (qty ? '<span class="cart-items__candy-thumb-qty">×' + qty + '</span>' : '') +
        '</span>';
    });

    return html;
  }

  function renderThumbnails() {
    var map = getMap();
    if (!map) return;

    document.querySelectorAll('.cart-items__properties').forEach(function (dl) {
      var targetDd = null;

      dl.querySelectorAll('dt').forEach(function (dt) {
        if (dt.textContent.trim().replace(/:$/, '') === PROPERTY_NAME) {
          targetDd = dt.nextElementSibling;
        }
      });

      var existing = dl.parentElement.querySelector('[data-candy-thumbs]');
      if (existing) existing.remove();

      if (!targetDd) return;

      var thumbsHtml = buildThumbsHtml(targetDd.textContent.trim(), map);
      if (!thumbsHtml) return;

      var wrap = document.createElement('div');
      wrap.className = 'cart-items__candy-thumbs';
      wrap.setAttribute('data-candy-thumbs', '');
      wrap.innerHTML = thumbsHtml;
      dl.insertAdjacentElement('afterend', wrap);
    });
  }

  document.addEventListener('shopify:cart:lines-update', function (event) {
    if (event.promise && typeof event.promise.then === 'function') {
      event.promise.then(renderThumbnails, renderThumbnails);
    } else {
      renderThumbnails();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderThumbnails);
  } else {
    renderThumbnails();
  }
})();
